/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.assignments.rpc.PortalChirpService
 */
import * as References from './PortalChirpService';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.assignments.rpc.PortalChirpService#get
 */
export const GET_QUERY_FIELD_NAME = 'com_hubspot_learning_center_assignments_rpc_PortalChirpService_get';
export const GET_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_QUERY_FIELD_NAME,
  args: ['targetPortalId'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.assignments.rpc.PortalChirpService#getPortalTeams
 */
export const GET_PORTAL_TEAMS_QUERY_FIELD_NAME = 'com_hubspot_learning_center_assignments_rpc_PortalChirpService_getPortalTeams';
export const GET_PORTAL_TEAMS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PORTAL_TEAMS_QUERY_FIELD_NAME,
  args: ['targetPortalId'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getPortalTeamsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});